module.exports = __webpack_public_path__ + "static/media/bootstrap.2ef3524e.png";